__turbopack_context__.v({
  "brandBackground": "CTASection-module__-LzqAG__brandBackground",
  "brandDescription": "CTASection-module__-LzqAG__brandDescription",
  "brandOutlineButton": "CTASection-module__-LzqAG__brandOutlineButton",
  "brandPrimaryButton": "CTASection-module__-LzqAG__brandPrimaryButton",
  "primaryButton": "CTASection-module__-LzqAG__primaryButton",
  "textureOverlay": "CTASection-module__-LzqAG__textureOverlay",
});
